
    import './styles.scoped.css';
    export default {
  "dialog": "_dialog_1k3xu_11",
  "modal-slide-up": "_modal-slide-up_1k3xu_1",
  "awsui-motion-fade-in-0": "_awsui-motion-fade-in-0_1k3xu_1",
  "overlay": "_overlay_1k3xu_27",
  "awsui-motion-fade-in": "_awsui-motion-fade-in_1k3xu_1",
  "root": "_root_1k3xu_49",
  "hidden": "_hidden_1k3xu_70",
  "focus-lock": "_focus-lock_1k3xu_84",
  "small": "_small_1k3xu_102",
  "medium": "_medium_1k3xu_105",
  "large": "_large_1k3xu_108",
  "max": "_max_1k3xu_111",
  "breakpoint-xs": "_breakpoint-xs_1k3xu_111",
  "container": "_container_1k3xu_116",
  "content": "_content_1k3xu_138",
  "inner-header": "_inner-header_1k3xu_142",
  "header": "_header_1k3xu_147",
  "header--text": "_header--text_1k3xu_153",
  "footer": "_footer_1k3xu_157",
  "dismiss-control": "_dismiss-control_1k3xu_167",
  "modal-open": "_modal-open_1k3xu_171"
};
  